import React from "react";
import { DetailCalloutProps } from "./DetailCallout.types";
import { Default } from "./variations/Default";
import { Default_v2 } from "./variations/Default_v2";

const FLEXIBLE_PAYMENT_OPTIONS_SECTION_ID = "flexible-payment-options";

const resolveCtaLocation = (sectionId?: string): string =>
  sectionId?.trim().toLowerCase() === FLEXIBLE_PAYMENT_OPTIONS_SECTION_ID ? "Flexible Payment Options" : "Detail Callout";

export const DetailCallout: React.FC<DetailCalloutProps> = ({ content, ...props }) => {
  const ctaLocation = resolveCtaLocation(props.section_id);

  if (content && content.length > 0) {
    return <Default_v2 content={content} ctaLocation={ctaLocation} {...props} />;
  }

  return <Default ctaLocation={ctaLocation} {...props} />;
};
